export const reStructureSelfPacedSegment = (fetchArray: any) => {
  const segmentsWithPage = fetchArray?.LearningTracks?.map((segment: any) => ({
    ...segment,
    page: fetchArray?.Page,
  }));

  return segmentsWithPage;
};

export const replaceSelfPacedArrayOfObjects = (fetchArray: any, existArray: any) => {
  const updatedArray = existArray?.map((segment: any, index: number) => {
    const fetchSegment = fetchArray?.find(
      (fs: any, index: number) =>
        fs.LearningTrackGuid === segment.LearningTrackGuid
    );
    return fetchSegment ? { ...segment, ...fetchSegment } : segment;
  });

  return updatedArray;
};
